export default __webpack_public_path__ + "static/media/Group 1542@2x.6a92755d.png";